// extracted by mini-css-extract-plugin
module.exports = {"possible-layout":"PossibleLayout_possible-layout__H_x3v"};